import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Pagination, StatusCode } from '../constants';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})

export class RoleService {
  constructor(private commonService: CommonService) { }

  getAll(pageSize: number = Pagination.PageSize, pageIndex: number = Pagination.PageIndex): Observable<ResponseResult> {
    return this.commonService.getAll(`role`, false, pageSize, pageIndex);
  }

  create(model): Observable<ResponseResult> {
    return this.commonService.createData(`role`, model);
  }

  update(model): Observable<ResponseResult> {
    return this.commonService.updateData(`role/${model.roleId}`, model);
  }

  delete(id): Observable<ResponseResult> {
    return this.commonService.deleteData(`role/${id}`);
  }
}
